<template>
    <div id="record">
        <div class="title">
            <a href="javascript:void(0)" :class="{active:currentType==='translate'}" @click="changeType('translate')">翻译记录</a>
            <a href="javascript:void(0)" :class="{active:currentType==='review'}" @click="changeType('review')">审校记录</a>
            <a href="javascript:void(0)" :class="{active:currentType==='unified'}" @click="changeType('unified')">统稿记录</a>
        </div>
        <div class="main">
            <div class="tableData">
                <el-table :data="recordData" style="width: 100%"  v-loading="loading">
                    <el-table-column label="序号" type="index" :index="indexGender" width="60px" align="center">
                    </el-table-column>
                    <el-table-column label="任务名称" align="center" class-name="fileName" min-width="200px">
                        <template slot-scope="scope">
<!--                            <span v-if="scope.row.quests_type == 'test'">{{scope.row.name}}</span>-->
                            <router-link :to="'/'+dataType+'/detail?task_id='+scope.row.id+'&task_type='+scope.row.quests_type" title="点我查看任务详情">{{scope.row.name}}</router-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="任务文件" min-width="240px" align="center" class-name="fileList">
                        <template slot-scope="scope">
                            <p v-for="file in scope.row.quests_files" class="fileName" :key="file.id" :title="file.file_name">
                                {{file.file_name}}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="提交文件" align="center" class-name="fileList" min-width="240px">
                        <template slot-scope="scope">
                            <p v-for="file in scope.row.submit_files" class="fileName" :key="file.id" :title="file.file_name">
                                {{file.file_name}}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="修订文件" align="center" class-name="fileList" min-width="240px" v-if="currentType=='translate'">
                        <template slot-scope="scope">
                            <p v-for="file in scope.row.review_files" class="fileName" :key="file.id" :title="file.file_name">
                                {{file.file_name}}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" align="center" fit>
                        <template slot-scope="scope">
                            {{scope.row.current_status ? jobStatus[scope.row.current_status] : jobStatus[scope.row.current_state]}}
                            <el-tooltip class="item" effect="dark" :content="scope.row.failed_info" placement="bottom-end"
                                        v-if="scope.row.current_status=='quests_failed' || scope.row.current_state=='quests_failed'
                                || scope.row.current_status=='failed' || scope.row.current_state=='failed'">
                                <i class="el-icon-warning-outline"></i>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="创建时间" min-width="120px" align="center">
                    </el-table-column>
                    <el-table-column prop="success_time" label="完成时间" min-width="120px" align="center">
                    </el-table-column>
                </el-table>
            </div>
            <pagination :limit="limit" :offset="offset" :total="total" @changePage="changePage"/>
        </div>
    </div>
</template>

<script>
    import {jobRecord} from "../../api/translator";
    import pagination from "../../components/public/pagination";
    import {jobStatus} from "../../utils/statusDict";

    export default {
        name: "index",
        components:{pagination},
        data(){
            return{
                currentType: "translate",
                limit: 15,
                offset: 0,
                total: 0,
                recordData: [],
                dataType: 'translation_task',
                loading: false,
                jobStatus: jobStatus(),
                recordType : {
                    translate: 'translation_task',
                    review: 'review_task',
                    unified: 'draft_task',
                }
            }
        },
        methods:{
            indexGender(index){
                return index+=1;
            },
            changeType(typeName){
                this.currentType = typeName;
                this.dataType = this.recordType[this.currentType]
                this.$router.push({query:{record:typeName}});
                this.offset = 0;
                this.recordData = [];
                this.getRecordDataEvent(this.offset, typeName);
            },
            changePage(page){
                this.getRecordDataEvent(page, this.currentType);
            },
            async getRecordDataEvent(offset, recordType){
                this.loading = true;
                await jobRecord(offset, recordType, this.limit)
                    .then(res=>{
                        this.loading = false;
                        this.recordData = res.results;
                        this.offset = offset + 1;
                        this.total = res.total;
                    })
                    .catch(error=>{
                        this.$message.error(error.data.error)
                        this.loading = false;
                    })
            }
        },
        created() {
            let allowRecord = ['translate', 'review', 'unified']
            if(this.$route.query.record && allowRecord.includes(this.$route.query.record)){
                this.currentType = this.$route.query.record
            }else{
                this.currentType = "translate";
                this.$router.push({query:{record:"translate"}})
            }
            this.dataType = this.recordType[this.currentType]

            this.getRecordDataEvent(this.offset, this.currentType)
        }
    }
</script>

<style scoped lang="scss">
    $bgColor: #0755a2;
    $titleHeight: 60px;
    #record {
        width: 90%;
        height: auto;
        min-height: 40vh;
        border: 1px solid $bgColor;
        border-radius: 4px;
        margin: 0 auto 200px;
        background-color: #fff;
        transition: .5s all;

        .title {
            width: 100%;
            height: $titleHeight;
            display: flex;
            align-items: center;
            background-color: #f6f6f6;
            margin-bottom: 10px;
        }

        .title > a {
            width: 50%;
            line-height: $titleHeight;
            display: flex;
            align-items: center;
            justify-content: center;
            letter-spacing: 4px;
            font-size: 26px;
            color: $bgColor;
            transition: .15s all ease-out;
        }
        .title > .active{
            width: 50%;
            background-color: $bgColor;
            color: #fff;
        }
    }

    @media (max-width: 1200px) {
        #record {
            min-width: 1150px;
        }
    }

    .fileName{
        overflow: hidden;
        text-wrap: none;
        white-space: nowrap;
        text-overflow: ellipsis;
        /*max-width: 200px;*/
        text-align: center;
        cursor: default;
    }
</style>
